import { Routes } from "@angular/router";
import { InterventionTrackerComponent } from "./intervention-tracker/intervention-tracker.component";
import { MsalGuard } from "@azure/msal-angular";
import { HelpPageComponent } from "./help/help.component";
import { HomeComponent } from "./home/home.component";
import { InterventionAnalyticsComponent } from "./intervention-analytics/intervention-analytics.component";
import { UserRole } from "../enums/user-role.enum";
import { rbacGuard } from "../guards/rbac.guard";

export const routes: Routes = [
    {
        path: "",
        component: HomeComponent,
    },
    {
        path: "intervention-tracker",
        component: InterventionTrackerComponent,
        canActivate: [MsalGuard, rbacGuard],
        data: { roles: [ UserRole.SuperUser, UserRole.Contractor ] }
    },
    {
        path: "intervention-analytics",
        component: InterventionAnalyticsComponent,
        canActivate: [MsalGuard, rbacGuard],
        data: { roles: [ UserRole.SuperUser] }
    },
    {
        path: "help",
        component: HelpPageComponent,
        canActivate: [MsalGuard, rbacGuard],
        data: { roles: [ UserRole.SuperUser, UserRole.Contractor] }
    },
    {
        path: '**', // This matches any undefined route
        redirectTo: '', // Redirect to the home page
        pathMatch: 'full',
    },
];
